import React from 'react';

import css from './ProgressBar.module.css';

function ProgressBar({ current, total }) {
  return (
    <div className={css.root}>
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={index}
          className={`${css.step} ${
            index < current ? css.active : ''
          }`}
        />
      ))}
    </div>
  );
}

export default ProgressBar;